import { z } from 'zod';
import { StarSystemClientSchema, StarLaneClientSchema } from './star-system.js';
import { ResourceDepositSchema } from './economy.js';

export const GalaxyMapResponseSchema = z.object({
  worldId: z.string().uuid(),
  seed: z.string(),
  systemCount: z.number().int(),
  systems: z.array(StarSystemClientSchema),
  lanes: z.array(StarLaneClientSchema),
  generatedAt: z.string().datetime(),
  /** Server GAME_SPEED (1 in production): the client divides game durations by it to show real ETAs. */
  gameSpeed: z.number().positive().default(1),
});
export type GalaxyMapResponse = z.infer<typeof GalaxyMapResponseSchema>;

export const SystemDetailResponseSchema = StarSystemClientSchema.extend({
  neighbors: z.array(z.object({
    systemId: z.string().uuid(),
    laneId: z.string().uuid(),
    distance: z.number().positive().optional(),
  })),
  deposits: z.array(ResourceDepositSchema).optional(),
});
export type SystemDetailResponse = z.infer<typeof SystemDetailResponseSchema>;
